import styles from "./benefit-item.module.css";
import { CircleCheck } from "lucide-react";

const BenefitItem = ({ benefit = {} }) => {
  let { title, description } = benefit;

  if (!title || !description) {
    return null;
  }

  return (
    <div className={styles.benefit}>
      <CircleCheck
        size={20}
        className="icon icon-success"
        data-testid="data-test-icon"
      />
      <div className={styles["benefit-content"]}>
        <h3 className="title-3">{title}</h3>
        <p className="subtitle-2">{description}</p>
      </div>
    </div>
  );
};

export default BenefitItem;
